import { Colors } from '../../Utility/Colors'
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useLocation, useNavigate } from 'react-router-dom';
import { QMS_TOKEN_WEBSOCKET, WEB_SOCKET_DOMAIN } from '../../Utility/Serviceurls';

const QmsTokenScreen = () => {
    const location = useLocation();
    const { channelName, clinicName, orgId, fo_call_channel_name } = location.state ? location.state : {};
    const [TokenList, setTokenList] = useState([]);
    const [time, setTime] = useState(new Date());
    const [speakFlag, setSpeakFlag] = useState(false)
    const navigate = useNavigate();
    const TokenSocket = useRef(null); // Use useRef to store WebSocket
    const reconnectTimeout = useRef(null);
    const isUnmounted = useRef(false);
    const reconnectAttempts = useRef(0);
    const RemoveSocket = useRef(null);
    const removeReconnectTimeout = useRef(null);
    const removeReconnectAttempts = useRef(0);
    const MAX_RECONNECT_ATTEMPTS = 5;

    const isSpeakingRef = useRef(false);
    const speechQueueRef = useRef([]);

    const processSpeechQueue = useCallback(() => {
        if (isSpeakingRef.current) return;
        if (speechQueueRef.current.length === 0) return;

        const token = speechQueueRef.current.shift();
        speakToken(token);
    }, []);

    useEffect(() => {
        isUnmounted.current = false;
        reconnectAttempts.current = 0;
        removeReconnectAttempts.current = 0;

        websocketConnection();
        removeWebsocketConnection();

        // Update time every minute
        const interval = setInterval(() => {
            setTime(new Date());
        }, 60000);

        // Clean up on component unmount
        return () => {
            isUnmounted.current = true;

            if (TokenSocket.current) {
                TokenSocket.current.close(1000, 'Component unmounted');
                TokenSocket.current = null;
            }
            if (RemoveSocket.current) {
                RemoveSocket.current.close(1000, 'Component unmounted');
                RemoveSocket.current = null;
            };
            if (reconnectTimeout.current) {
                clearTimeout(reconnectTimeout.current);
                reconnectTimeout.current = null;
            }
            if (removeReconnectTimeout.current) {
                clearTimeout(removeReconnectTimeout.current);
                removeReconnectTimeout.current = null;
            }
            clearInterval(interval);

            window.speechSynthesis.cancel();
            speechQueueRef.current = [];
            isSpeakingRef.current = false;
        };
    }, []);

    // useEffect(() => {
    //     if (TokenList?.length > 0 && speakFlag) {
    //         speak();
    //         setSpeakFlag(false)
    //     }
    // }, [speakFlag, TokenList])

    const removeWebsocketConnection = useCallback(() => {

        // prevent duplicate connections
        if (
            RemoveSocket.current &&
            (RemoveSocket.current.readyState === WebSocket.OPEN ||
                RemoveSocket.current.readyState === WebSocket.CONNECTING)
        ) {
            return;
        }

        // stop after max attempts
        if (removeReconnectAttempts.current >= MAX_RECONNECT_ATTEMPTS) {
            console.log('Remove WS: max reconnect attempts reached');
            return;
        }

        // clear pending timer
        if (removeReconnectTimeout.current) {
            clearTimeout(removeReconnectTimeout.current);
            removeReconnectTimeout.current = null;
        }

        try {
            const socket = new WebSocket(`${WEB_SOCKET_DOMAIN}${QMS_TOKEN_WEBSOCKET}${fo_call_channel_name}/?org_id=${orgId}`);

            RemoveSocket.current = socket;

            socket.onopen = () => {
                console.log('Remove WebSocket connected');
                removeReconnectAttempts.current = 0;
            };

            socket.onerror = (err) => {
                console.error('Remove WS error', err);
                socket.close();
            };

            socket.onclose = (event) => {
                console.log('Remove WebSocket closed:', event.code);

                RemoveSocket.current = null;

                // do not reconnect on normal close or unmount
                if (event.code === 1000 || isUnmounted.current) {
                    console.log('Normal closure or component unmounted. No remove reconnection.');
                    return;
                }

                // reconnect
                removeReconnectAttempts.current += 1;
                const delay = Math.min(
                    1000 * Math.pow(2, removeReconnectAttempts.current),
                    30000
                );

                console.log(`Remove WS reconnecting in ${delay}ms`);

                removeReconnectTimeout.current = setTimeout(() => {
                    if (!isUnmounted.current) {
                        removeWebsocketConnection();
                    }
                }, delay);
            };

            socket.onmessage = (e) => {
                try {
                    const data = JSON.parse(e.data);
                    console.log('Remove WS data:', data);

                    if (data?.action === "remove_message" && data?.message_id) {
                        setTokenList(prev => {
                            const filtered = prev.filter(item => item?.message_id !== data.message_id);
                            return filtered;
                        });
                    }
                } catch (err) {
                    console.error('Remove WS parse error', err);
                }
            };

        } catch (err) {
            console.error('Remove WS creation error', err);
        }
    }, [fo_call_channel_name, orgId]);


    const websocketConnection = useCallback(() => {
        if (TokenSocket.current && (TokenSocket.current.readyState === WebSocket.OPEN || TokenSocket.current.readyState === WebSocket.CONNECTING)) {
            return;
        }

        if (reconnectTimeout.current) {
            clearTimeout(reconnectTimeout.current);
            reconnectTimeout.current = null;
        }

        if (reconnectAttempts.current >= MAX_RECONNECT_ATTEMPTS) {
            console.log('Max reconnection attempts reached');
            return;
        }
        try {
            // Initialize WebSocket connection
            const socket = new WebSocket(`${WEB_SOCKET_DOMAIN}${QMS_TOKEN_WEBSOCKET}${channelName}/?org_id=${orgId}`);

            TokenSocket.current = socket;

            socket.onopen = () => {
                console.log('WebSocket connected');
                reconnectAttempts.current = 0;
            };
            socket.onclose = (event) => {
                console.log('WebSocket disconnected. Code:', event.code, 'Reason:', event.reason);

                // Don't reconnect on normal closure or if component is unmounted
                if (event.code === 1000 || isUnmounted.current) {
                    console.log('Normal closure or component unmounted. No reconnection.');
                    return;
                }

                // Increment reconnect attempts
                reconnectAttempts.current += 1;

                // Exponential backoff for reconnection
                const delay = Math.min(1000 * Math.pow(2, reconnectAttempts.current), 30000);
                console.log(`Reconnecting in ${delay}ms... Attempt ${reconnectAttempts.current}`);


                reconnectTimeout.current = setTimeout(() => {
                    if (!isUnmounted.current) {
                        websocketConnection();
                    }
                }, delay);

            };
            socket.onerror = (error) => {
                console.error('WebSocket Error', error);
                socket.close();
            };
            socket.onmessage = (e) => {
                try {
                    const data = JSON.parse(e.data);
                    setTokenList(prevList => {
                        const newList = [...prevList];
                        // if (data?.remove_message_id) {
                        //     let Array = newList.filter((item) => (item?.message_id !== data?.remove_message_id))
                        //     return Array;

                        // } else {
                        if (newList.length >= 4) {
                            newList.pop();
                        }
                        newList.unshift(data);
                        return newList;
                        // }
                    });
                    // if (!data?.remove_message_id) {
                    //     setSpeakFlag(true)
                    // }
                    speechQueueRef.current.push(data);
                    processSpeechQueue();
                    console.log('WebSocket Message', data);
                } catch (error) {
                    console.error('Error parsing WebSocket message:', error);
                }
            };
        } catch (error) {
            console.error('Error creating WebSocket:', error);
        }
    }, [channelName, orgId]);

    const formatTime = (date) => {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    };

    const renderBackScreen = () => {
        navigate(-1);
    };

    // const speak = useCallback(() => {
    //     if ('speechSynthesis' in window && TokenList.length > 0) {
    //         window.speechSynthesis.cancel(); // prevent overlap
    //         let text = (TokenList[0]?.token_no ? ` Token Number ${TokenList[0]?.token_no}` : "") + ". " + (TokenList[0]?.room_no ? `Room Number ${TokenList[0]?.room_no}` : "") + ". " + (TokenList[0]?.doctor_name ? `Doctor Name ${TokenList[0]?.doctor_name}` : "") + ". ";
    //         const speech = new SpeechSynthesisUtterance(text);
    //         speech.lang = 'en-IN'; // Set the language to English (India)

    //         speech.rate = 0.8
    //         speech.pitch = 1.2

    //         // Get the list of available voices
    //         const voices = window.speechSynthesis.getVoices();

    //         // Select a female voice, or fallback to the first available voice
    //         const femaleVoice = voices.find(voice =>
    //             voice.name.toLowerCase().includes('female') ||
    //             voice.name.toLowerCase().includes('woman') ||
    //             voice.gender === 'female'
    //         );

    //         if (femaleVoice) {
    //             speech.voice = femaleVoice;
    //         } else if (voices.length > 0) {
    //             speech.voice = voices[0]; // fallback to the first available voice
    //         }

    //         // Speak the text
    //         window.speechSynthesis.speak(speech);
    //     } else {
    //         alert('Sorry, your browser does not support text-to-speech.');
    //     }
    // },[TokenList]);

    // const speak = useCallback(() => {
    //     if (!('speechSynthesis' in window) || TokenList.length === 0) return;

    //     const speakNow = () => {
    //         window.speechSynthesis.cancel();

    //         const text = `Token Number ${TokenList[0]?.token_no}. 
    //   Room Number ${TokenList[0]?.room_no}. 
    //   Doctor Name ${TokenList[0]?.doctor_name}.`;

    //         const speech = new SpeechSynthesisUtterance(text);
    //         speech.lang = 'en-IN';
    //         speech.rate = 0.8;
    //         speech.pitch = 1.2;

    //         const voices = window.speechSynthesis.getVoices();
    //         speech.voice = voices.find(v => v.lang === 'en-IN') || voices[0];

    //         window.speechSynthesis.speak(speech);
    //     };

    //     if (window.speechSynthesis.getVoices().length === 0) {
    //         window.speechSynthesis.onvoiceschanged = speakNow;
    //     } else {
    //         speakNow();
    //     }
    // }, [TokenList]);


    const speakToken = useCallback(
        (token) => {
            if (!('speechSynthesis' in window)) return;

            isSpeakingRef.current = true;

            const text = `Token Number ${token?.token_no}. 
                          Room Number ${token?.room_no}. 
                          Doctor Name ${token?.doctor_name}.`;

            const speech = new SpeechSynthesisUtterance(text);
            speech.lang = 'en-IN';
            speech.rate = 0.8;
            speech.pitch = 1.2;

            const voices = window.speechSynthesis.getVoices();
            speech.voice = voices.find(v => v.lang === 'en-IN') || voices[0];

            speech.onend = () => {
                isSpeakingRef.current = false;
                processSpeechQueue();
            };

            speech.onerror = () => {
                isSpeakingRef.current = false;
                processSpeechQueue();
            };

            window.speechSynthesis.speak(speech);
        },
        [processSpeechQueue]
    );


    return (
        <div style={{ margin: '1vw' }}>
            <Box sx={{ backgroundColor: '#04B7B1', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1vw' }}>
                <IconButton sx={{ width: '2vw' }} onClick={renderBackScreen}>
                    <ArrowBackIosNewIcon style={{ color: 'white' }} />
                </IconButton>
                <Box sx={{ fontSize: '3rem', color: 'white', fontWeight: 700 }}>{clinicName}</Box>
                <Box sx={{ fontSize: '3rem', color: 'white', fontWeight: 700 }}>
                    {formatTime(time)}
                </Box>
            </Box>
            <TableContainer sx={{ border: '1px solid lightgray', height: '80vh', backgroundColor: 'white', marginTop: '1vw' }}>
                <Table size='small' sx={{ overflowY: 'scroll' }}>
                    <TableHead>
                        <TableRow sx={{ height: '12vh', backgroundColor: Colors.ThemeLightColor }}>
                            <TableCell align='center' sx={{ fontWeight: '600', borderRight: '1px solid lightgray', fontSize: '2.5vw' }}>
                                <Box sx={{ fontSize: '2.5vw', fontWeight: 600 }}>Token</Box>
                            </TableCell>
                            <TableCell align='center' sx={{ fontWeight: '600', borderRight: '1px solid lightgray', fontSize: '2.5vw' }}>
                                <Box sx={{ fontSize: '2.5vw', fontWeight: 600 }}>Room</Box>
                            </TableCell>
                            <TableCell align='center' sx={{ fontWeight: '600', borderRight: '1px solid lightgray', fontSize: '2.5vw', fontWeight: 800 }}>
                                <Box sx={{ fontSize: '2.5vw', fontWeight: 600 }}>Patient Name</Box>
                            </TableCell>
                            <TableCell align='center' sx={{ fontWeight: '600', borderRight: '1px solid lightgray', fontSize: '2.5vw' }}>
                                <Box sx={{ fontSize: '2.5vw', fontWeight: 600 }}>Doctor Name</Box>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {TokenList.length > 0 && TokenList.map((list, index) => (
                            <TableRow key={index} sx={{ height: '12vh' }}>
                                <TableCell align='center' sx={{ borderRight: '1px solid lightgray', fontSize: '2.5vw', font: 'caption' }}>
                                    <Box sx={{ fontSize: '3.5vw', fontWeight: 800, color: 'red' }}>{list?.token_no}</Box>
                                </TableCell>
                                <TableCell align='center' sx={{ borderRight: '1px solid lightgray', fontSize: '2.5vw', font: 'caption' }}>
                                    <Box sx={{ fontSize: '2.5vw', fontWeight: 600 }}>{list?.room_no}</Box>
                                </TableCell>
                                <TableCell align='center' sx={{ borderRight: '1px solid lightgray' }}>
                                    <Box sx={{ fontSize: '2.5vw', fontWeight: 600 }}>{list?.patient_name}</Box>
                                </TableCell>
                                <TableCell align='center' sx={{ borderRight: '1px solid lightgray', fontSize: '2.5vw', font: 'caption' }}>
                                    <Box sx={{ fontSize: '2.5vw', fontWeight: 600 }}>{list?.doctor_name}</Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

export default QmsTokenScreen;